export const PAGE_TYPES = {
    LAW: "LAW",
    JURIS: "JURIS",
    DOCS: "DOCS",
    TELE: "TELE"
};
